export const serializeToJSON = (arr) => {
    let result = {};

    arr.forEach((item) => {
        result[item.name] = item.value;
    });

    return result;
};
